import Bridge from '../Bridge';
import { loginValidator } from './loginValidator';

export default new Bridge('LoginInput', loginValidator, {});

